export const appName = 'This is Cupertino UI';
